import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-649aee78")

_pushScopeId("data-v-649aee78")
const _hoisted_1 = { class: "reminder_main" }
const _hoisted_2 = { class: "reminder_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "reminder_title" }, " Important Notice ", -1)
const _hoisted_4 = { class: "anti_body" }
const _hoisted_5 = { class: "anti_farkurl" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "anti_farklogo" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "anti_farktext" }, "Scan QR Code to Verify Report Authenticity", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", {
        class: "reminder_cnt",
        innerHTML: _ctx.getData("content") || _ctx.getData("reminderContent")
      }, null, 8, ["innerHTML"])
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("img", {
          src: _ctx.state.antiFakeUrl
        }, null, 8, ["src"]),
        _hoisted_6
      ]),
      _hoisted_7
    ], 512), [
      [_vShow, _ctx.state.isShpwAntiFake]
    ])
  ]))
})